import { createMediaMathClient } from "@/apis/clients/mediamathClient";
import { fetchAllPages, MAX_PAGE_LIMIT } from "@/apis/clients/pagination";
import type { AgencyListResponse } from "@/types/agency";

// Conditions in `q` are separated by `&` and combined with AND. That is the
// same character the query string itself uses, so the value has to reach the
// API encoded — ky does that for us here.
//
// Only active agencies: an inactive one cannot be chosen for a user, and
// showing it in a picker offers something that will not work. Measured against
// QA org 102808: 149 agencies, 138 of them active.
const listAgenciesPage = (organizationId: number, pageOffset: number) =>
  createMediaMathClient()
    .get("agencies", {
      timeout: 90000,
      searchParams: {
        q: `organization_id==${organizationId}&status==true`,
        page_limit: MAX_PAGE_LIMIT,
        page_offset: pageOffset,
      },
    })
    .json<AgencyListResponse>();

export const listAgencies = (organizationId: number) =>
  fetchAllPages((pageOffset) => listAgenciesPage(organizationId, pageOffset));
